import { configureStore, combineReducers } from "@reduxjs/toolkit";
import errorHandlerSlice from "@/reducers/errorHandler/errorHandlerSlice";
import userSlice from "../reducers/user/userSlice";
import globalConfigSlice from "@/reducers/globalConfig/globalConfigSlice";
import registrationJourneySlice from "@/reducers/registrationJourney/registrationJourneySlice";
import forgotPasswordJourneySlice from "@/reducers/forgotPasswordJourney/forgotPasswordJourneySlice";
import storage from "redux-persist/lib/storage";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import viewServiceRequestSlice from "@/reducers/viewServiceRequestJourney/viewServiceRequestSlice";
import currentPropertyJourneySlice from "@/reducers/currentPropertyJourney/currentPropertyJourneySlice";
import currentPaymentJourneySlice from "@/reducers/paymentJourney/currentPaymentJourneySlice";
import fastrackJourneySlice from "@/reducers/fastrackJourney/fastrackJourneySlice";
import currentServiceRequestCreationJourneySlice from "@/reducers/currentServiceRequestCreationJourney/currentServiceRequestCreationJourneySlice";
import currentFinancialStatementJourneySlice from "@/reducers/currentFinancialStatementJourney/currentFinancialStatementJourneySlice";
import currentServiceRequestFilterJourneySlice from "@/reducers/currentServiceRequestFilterJourney/currentServiceRequestFilterJourneySlice";
import currentNewsJourneySlice from "@/reducers/currentNewsJourney/currentNewsJourneySlice";
import loginRegularJourneySlice from "@/reducers/loginRegularJourney/loginRegularJourneySlice";
import portalUsersSlice from "@/reducers/portalUsers/portalUsersSlice";
import newServiceRequestReducer from '@/reducers/newDLPServiceRequest/newServiceRequestSlice';
import propertyJourneyStatusSlice from "@/reducers/propertyJourneyStatus/propertyJourneyStatusSlice";
import serviceFeeJourneySlice from "@/reducers/serviceFeeJourney/serviceFeeJourneySlice";
import nocJourneySlice from "@/reducers/nocJourney/nocJourneySlice";
import guestManagementReducer from "@/reducers/guestManagement/guestManagementSlice";
import createServiceRequestSlice from "@/reducers/createServiceRequest/createServiceRequestSlice";
import livingInJourney from "@/reducers/livingInJourney/livingInJourneySlice";
import featureFlagSlice from '@/reducers/featureFlag/featureFlagSlice';
import configurableContentSlice from "@/reducers/configurableContents/configurableContentsSlice";
import commonDialogPopupSlice from "@/reducers/commonDialogPopup/commonDialogPopupSlice";
import digitalSalesSlice from '@/reducers/digitalSales/digitalSalesSlice';
import moveInJourneySlice from '@/reducers/moveInJourney/moveInJourneySlice';
import forgerockUserInfoSlice from '@/reducers/forgerockUserInfo/forgerockUserInfoSlice';
import homeContentsSlice from '@/reducers/homeContents/homeContentsSlice';
import garageCustomizationReducer from "@/reducers/garageCustomization";
import generalServicesSlice from "@/reducers/generalServices/generalServicesSlice";
import moveOutJourneySlice from '@/reducers/moveOutJourney/moveOutJourneySlice';
import leaseJourney from "@/reducers/leaseJourney/leaseJourneySlice";
import tenantOnboardingSlice from "@/reducers/tenantOnboarding/tenantOnboardingSlice";
import leadToleaseJourneyReducer from "@/reducers/leadToleaseJourney/leadToleaseJourneySlice";
import offplanTransferSlice from '@/reducers/offplanTransfer/offplanTransferSlice';
import serviceRequestCatalogReducer from '@/reducers/serviceRequestCatalog/serviceRequestCatalogSlice';
import expressionOfInterestSlice from '@/reducers/expressionOfInterest/expressionOfInterestSlice';
import bookingJourneySlice from '@/reducers/bookingJourney/bookingJourneySlice';
import leasePaymentsReducer from "@/reducers/leasePayments/leasePaymentsSlice";
import occupantOnboardingReducer from "@/reducers/occupantOnboarding/occupantOnboardingSlice";
import aipMoveInSlice from '@/reducers/aipMoveIn/aipMoveInSlice';

const persistConfig = {
  key: 'root',
  storage,
}


const rootReducer = combineReducers({
  user: userSlice,
  globalConfig: globalConfigSlice,
  registrationJourney: registrationJourneySlice,
  forgotPasswordJourney: forgotPasswordJourneySlice,
  loginRegularJourney: loginRegularJourneySlice,
  propertyJourneyStatus: propertyJourneyStatusSlice,
  currentServiceRequest: viewServiceRequestSlice,
  currentPropertyJourney: currentPropertyJourneySlice,
  currentPaymentJourney: currentPaymentJourneySlice,
  fastrackJourney: fastrackJourneySlice,
  errorHandler: errorHandlerSlice,
  currentServiceRequestCreationJourney: currentServiceRequestCreationJourneySlice,
  currentFinancialStatementJourney: currentFinancialStatementJourneySlice,
  currentServiceRequestFilterJourney: currentServiceRequestFilterJourneySlice,
  currentNewsJourney: currentNewsJourneySlice,
  portalUsers: portalUsersSlice,
  serviceFee:serviceFeeJourneySlice,
  nocService:nocJourneySlice,
  newServiceRequest: newServiceRequestReducer,
  guestManagement:guestManagementReducer,
  createServiceRequest:createServiceRequestSlice,
  livingInJourney:livingInJourney,
  featureFlagsReducer: featureFlagSlice,
  configurableContents: configurableContentSlice,
  commonDialogHandler: commonDialogPopupSlice,
  digitalSalesReducer: digitalSalesSlice,
  moveInJourney:moveInJourneySlice,
  forgerockUserInfoReducer: forgerockUserInfoSlice,
  homeContentSlice: homeContentsSlice,
  garageCustomization: garageCustomizationReducer,
  leaseJourney: leaseJourney,
  generalServices: generalServicesSlice,
  moveOutJourney:moveOutJourneySlice,
  tenantOnboarding: tenantOnboardingSlice,
  leadToleaseJourney: leadToleaseJourneyReducer,
  offplanTransfer: offplanTransferSlice,
  serviceRequestCatalog: serviceRequestCatalogReducer,
  expressionOfInterest: expressionOfInterestSlice,
  bookingJourney: bookingJourneySlice,
  leasePayments: leasePaymentsReducer,
  occupantOnboarding: occupantOnboardingReducer,
  aipMoveIn: aipMoveInSlice,
});
export const persistedRootReducer = persistReducer(persistConfig, rootReducer);

export const store: any = configureStore({
  reducer: persistedRootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
